module.exports = __webpack_public_path__ + "static/img/yi3.9384e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yi3.jpg
// module id = 3+6J
// module chunks = 0